export default __webpack_public_path__ + "static/family_gaming-6b63f668255c6f6b4f5772b1f0600b39.jpg";